export default "__VITE_ASSET__sK3fMvj9__"